import React from 'react';
import './terms-conditions.css';

const InterestRatePolicy = () => {
  return (
    <div className="tc-container">
      <header className="tc-header mb-3">
        <h1>Interest Rate Policy</h1>
      </header>

      <section className="tc-content mb-3">
        <h5 className="text-center mb-4"> <b>SINGH FINLEASE PRIVATE LIMITED</b> </h5>
        
        <h2>1. Preface</h2>
        <p>
          In accordance with the Reserve Bank of India (RBI) guidelines on Fair Practices Code for NBFCs, 
          <b> Singh Finlease Private Limited ("The Company")</b> has adopted this Interest Rate Policy. 
          This policy outlines the model for charging interest and the approach for risk gradation for 
          the lending business operated under the brand <b>"Loanonsalary"</b>.
        </p>

        <h2>2. Interest Rate Model</h2>
        <p>
          The Company focuses on providing credit to customers meeting its internal credit standards. 
          The interest rate for each loan is assessed based on the following factors:
        </p>
        <ul>
          <li><strong>Cost of Funds:</strong> The internal and external cost of sourcing capital and expected return on equity.</li>
          <li><strong>Operating Cost:</strong> The cost of doing business, including technology expenses, employee costs, and location-specific administrative costs.</li>
          <li><strong>Credit Risk:</strong> A risk premium is factored in based on the borrower’s credit profile and the probability of default.</li>
          <li><strong>Market Dynamics:</strong> Prevailing interest rates offered by peer NBFCs and market liquidity conditions.</li>
          <li><strong>Tenor of the Loan:</strong> Since we specialize in short-term credit (30-90 days), the pricing reflects the high-frequency nature of these advances.</li>
        </ul>

        <h2>3. Approach for Gradation of Risk</h2>
        <p>
          We do not follow a "one size fits all" approach. The risk premium is attached based on:
        </p>
        <ul>
          <li>Borrower’s profile and past repayment track record.</li>
          <li>Stability of earnings and employment.</li>
          <li>Credit Bureau (CIBIL/Experian) scores and reports.</li>
          <li>Nature of the loan product and perceived segment risk.</li>
        </ul>

        <h2>4. Key Rate Details</h2>
        <p>
          <b>a. Annualized Rate of Interest (APR):</b> The interest rates are annualized to provide clarity. 
          Our APR generally ranges from <b>200% to 365%</b>, depending on the risk assessment of the applicant.
        </p>
        <p>
          <b>b. Communication:</b> The specific rate of interest and the tenure will be clearly communicated 
          to the borrower in the <b>Sanction Letter</b>.
        </p>
        <p>
          <b>c. Penal Interest:</b> Any delay in repayment will attract penal interest or late fees as 
          specified in the Loan Agreement. This will be mentioned in <b>bold</b> to ensure the borrower is aware.
        </p>

        <h2>5. Other Charges</h2>
        <p>
          Apart from interest, the Company may levy charges such as:
        </p>
        <ul>
          <li>Processing fees (deducted upfront or charged separately).</li>
          <li>Cheque bounce / NACH dishonor charges.</li>
          <li>Verification and Documentation charges.</li>
          <li>Applicable Taxes (GST) as per Government norms.</li>
        </ul>

        <h2>6. Policy Review</h2>
        <p>
          The Board of Directors will review the Interest Rate Policy and the benchmark rates periodically, 
          taking into account changes in RBI regulations and market volatility. Any change in interest 
          rates or charges will be applied prospectively.
        </p>

        <p className="mt-4">
          <i>Note: For any clarifications regarding your specific interest rate, please refer to your 
          Sanction Letter or contact us at info@loanonsalary.com.</i>
        </p>
      </section>
    </div>
  );
};

export default InterestRatePolicy;